import styled from 'styled-components';
export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
`;